module.exports = __webpack_public_path__ + "59f923f2ccb9945fb7d92811362c004d.ogg";